// NFC team logos
const nfcTeamLogos = {
    "Seattle Seahawks":
      "https://upload.wikimedia.org/wikipedia/en/thumb/8/8e/Seattle_Seahawks_logo.svg/1280px-Seattle_Seahawks_logo.svg.png",

    "Chicago Bears":
      "https://upload.wikimedia.org/wikipedia/en/thumb/1/15/Chicago_Bears_logo_primary.svg/1280px-Chicago_Bears_logo_primary.svg.png",

    "Philadelphia Eagles":
      "https://upload.wikimedia.org/wikipedia/en/thumb/8/8e/Philadelphia_Eagles_logo.svg/1280px-Philadelphia_Eagles_logo.svg.png",

    "Carolina Panthers":
      "https://upload.wikimedia.org/wikipedia/en/thumb/1/1c/Carolina_Panthers_logo.svg/1280px-Carolina_Panthers_logo.svg.png",

    "Los Angeles Rams":
      "https://upload.wikimedia.org/wikipedia/en/thumb/8/8a/Los_Angeles_Rams_logo.svg/1280px-Los_Angeles_Rams_logo.svg.png",

    "San Francisco 49ers":
      "https://upload.wikimedia.org/wikipedia/commons/3/3a/San_Francisco_49ers_logo.svg",

    "Green Bay Packers":
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/Green_Bay_Packers_logo.svg/1280px-Green_Bay_Packers_logo.svg.png",

    "Minnesota Vikings":
      "https://upload.wikimedia.org/wikipedia/en/thumb/4/48/Minnesota_Vikings_logo.svg/1280px-Minnesota_Vikings_logo.svg.png",

    "Detroit Lions":
      "https://upload.wikimedia.org/wikipedia/en/7/71/Detroit_Lions_logo.svg",

    "Tampa Bay Buccaneers":
      "https://upload.wikimedia.org/wikipedia/en/thumb/a/a2/Tampa_Bay_Buccaneers_logo.svg/1280px-Tampa_Bay_Buccaneers_logo.svg.png",

    "Atlanta Falcons":
      "https://upload.wikimedia.org/wikipedia/en/thumb/c/c5/Atlanta_Falcons_logo.svg/1280px-Atlanta_Falcons_logo.svg.png",

    "Dallas Cowboys":
      "https://upload.wikimedia.org/wikipedia/commons/1/15/Dallas_Cowboys.svg",

    "New Orleans Saints":
      "https://upload.wikimedia.org/wikipedia/commons/thumb/5/50/New_Orleans_Saints_logo.svg/1280px-New_Orleans_Saints_logo.svg.png",

    "Washington Commanders":
      "https://static.www.nfl.com/t_person_squared_mobile/f_auto/league/api/clubs/logos/WAS",

    "New York Giants":
      "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/New_York_Giants_logo.svg/1280px-New_York_Giants_logo.svg.png",

    "Arizona Cardinals":
      "https://upload.wikimedia.org/wikipedia/en/thumb/7/72/Arizona_Cardinals_logo.svg/1280px-Arizona_Cardinals_logo.svg.png",
};

export default nfcTeamLogos;